import React,{useState,useEffect,useContext} from 'react'
import {Row,Col} from "react-bootstrap"
import { InputGroup, InputGroupAddon, Input } from 'reactstrap';
import { Table } from 'reactstrap';
import { Card, Button, CardTitle, CardText } from 'reactstrap';
import {Modal} from "react-bootstrap"
import Axios from "axios"
import 'bootstrap/dist/css/bootstrap.min.css';
import "../../App.css"
import {UserContext} from "../Context/UserContext"
import { base_url } from '../../globalConstants';


function MyVerticallyCenteredModal(props) {

 
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            More Ledger Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>Details are such as follows</h4>
          <p>
            More details will be displayed here
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
  

export default function Ledger() {
  
    const [modalShow, setModalShow] = React.useState(false);
    const [EzzId, setEzzId]=useState('');
    const [Details,setDetails]=useState([]);
    const [Count,setCount]=useState(100);



    const fetchDetails=async e=>{
      const response=await Axios.get(base_url + `payments/?ezz_id=${EzzId}`);
      const {data}=response
    console.log(data);
      setDetails(data);
     

    }
  useEffect(()=>{
    setEzzId(localStorage.getItem('ezzyid'));
    fetchDetails();
    
  
    
  },)

 function handleModal(key){
   setModalShow(true);
   
 }

    return (
        <div>
            <Row>
            <Col xs lg={9}>
            <h1 id="paymentreminder">Ledger</h1>
            </Col>
            <Col xs lg={3}>
            <InputGroup size="lg" >
            
            <Input placeholder="Search"/>
          </InputGroup>
            </Col>
            </Row>
            <div style={{float:"right"}}>
            <h5>Customer ID: {EzzId}</h5>
            </div>
            <Table hover>
            <thead>
              <tr>
                <th>Sr.No</th>
                <th>date</th>
                <th>Particulars</th>
                <th>Amount</th>
                <th>Transaction No.</th>
              </tr>
            </thead>
            <tbody>
             {Details.map(key=>(
               <>
               <tr onClick={()=>handleModal(key.id)}>
               <th scope="row">{key.id}</th>
               <td>{key.payment_date}</td>
               <td>{key.particulers}</td>
               <td>{key.payment_amount}</td>
               <td>{key.transaction_number}</td>
               </tr></>
             ))}
            </tbody>
          </Table>

          <MyVerticallyCenteredModal
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
            
        </div>


    )
}
